import {Component, Input, OnInit, Output, EventEmitter, ViewEncapsulation, SimpleChanges, OnChanges} from "@angular/core";
import { TRANSLOCO_SCOPE } from '@jsverse/transloco';
import { TaxReturnSubcategoryService } from "../subcategory/subcategory.service";
import { subcategoryTabs } from "../subcategory/subcategory.const";
import { ICommentField } from "../subcategory/subcategory";
import { ActivatedRoute } from "@angular/router";
import { TaxReturnsResolver } from "../../tax-returns-resolver";
import { ITaxReturn } from "../model/i-tax-return";
import { cloneDeep } from "lodash-es";
import { ConfigStateService } from "../../../config/config-state.service";
import { IAnswer, IFormField, makeControlForQuestion, setupDependantMandatory } from "../../../../shared/components/form-field-wrapper/form-field-wrapper.component";
import { UntypedFormGroup } from "@angular/forms";
import { UserInfoService } from "../../../user-info.service";

declare var $: any;

@Component({
    selector: "app-smart-form-view-table",
    templateUrl: "./smart-form-view-table.component.html",
    styleUrls: ["./smart-form-view-table.component.scss"],
    //encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: TRANSLOCO_SCOPE,
            useValue: { scope: "tax-returns", alias: "taxReturns" }
        }
    ],
    standalone: false
})
export class SmartFormViewTableComponent implements OnInit, OnChanges {
  smartFormTypeId: number;
  taxReturnId: number;
  taxYear = 2022;
  commentFields: ICommentField[] = [];
  smartForm;
  inputQuestionId: number;
  newSubGroupName: string;
  newSubGroupHash: string;
  newSubGroupOrder: number;
  newSubGroupFolderPath: string;
  newSubGroupDocRegexPattern: string;
  @Input() rowIndex;
  @Input() subGroup;
  @Input() readonly;
  @Input() inspectMode;
  @Input() deleted;
  @Input() groupId;
  @Input() rowAnswer;
  @Input() modernTable?: boolean;
  @Input() hideClearOverRideQuestionIcon = false;
  @Input() debugMode?: boolean;
  @Input() sideOpen: boolean;
  @Input() isFullScreenMode?: boolean;
  @Input() fullScreenSubGroup?: any;
  @Input() id?: number;
  @Input() isCollapsed: boolean; // whether card is collapsed
  @Input() isVisible?: boolean;
  @Input() formGroup: UntypedFormGroup;

  @Output() loadTrace = new EventEmitter();
  @Output() refreshTaxReturn: EventEmitter<any> = new EventEmitter();
  @Output() toggleFullScreen = new EventEmitter();
  @Output() handleAside = new EventEmitter();
  @Output() setCollapsedState: EventEmitter<{
    collapsed: boolean;
    groupId: number;
    subGroupId: number;
  }> = new EventEmitter();
  @Output() handleSaveTable = new EventEmitter();

  // from subcategory
  taxReturn: ITaxReturn;
  getCommentMeta: Function; // shared to comments cmp
  handleCommentReply: Function; // shared to comments cmp
  subscriptions = []; // TODO: clean this up on destroy
  columnOrdering = [];

  overRideFlag = "";
  tableCells;
  constructor(
    private activatedRoute: ActivatedRoute,
    private taxReturnsResolver: TaxReturnsResolver,
    private config: ConfigStateService,
    private userInfo: UserInfoService,
    private taxReturnSubcategoryService: TaxReturnSubcategoryService
  ) {}

  ngOnInit() {
    if (this.subGroup.isTable && this.modernTable) {
      this.subGroup.rows.forEach((r, idx) => {
        r.ordinal = idx;
      });
    }
    this.columnOrdering = this.updateColumnOrdering();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.subGroup || changes.debugMode) {
      this.columnOrdering = this.updateColumnOrdering();
    }
  }

  private getFormControl(q) {
    return this.rowIndex != null
      ? this.formGroup.get(`${q.id}-${this.rowIndex}`)
      : this.formGroup.controls[q.id];
  }
  getDisplayAnswer(cell) {
    const q = cell.question;
    const answerValue = cell.formControl
      ? cell.formControl.value
      : cell.answer.answer;
    if (q.displayFieldType === "drop down") {
      const selectedDropdown = answerValue
        ? q.questionDropdowns.find(qd => qd.value === answerValue)
        : null;
      return (
        (selectedDropdown != null && selectedDropdown.display) || answerValue
      );
    }
    return answerValue;
  }
  private getTableCells() {
    if (!this.subGroup) return false;
    const row = this.subGroup.rows[this.rowIndex];
    const cells = this.subGroup.questions
      .filter(q => !q.hidden)
      .map(columnQuestion => {
        const cellAnswer = row.cells[columnQuestion.id];
        const control = this.getFormControl(columnQuestion);
        columnQuestion.isBooleanCheckbox =
          columnQuestion.displayFieldType === "checkbox" &&
          columnQuestion.dataType === "boolean";
        columnQuestion.dropdownDirection = "downward";
        const cell = {
          question: columnQuestion,
          answer: cellAnswer,
          formControl: control,
          rowIndex: this.rowIndex,
          displayAnswer: ""
        };
        cell.displayAnswer = this.getDisplayAnswer(cell);
        return cell;
      });
    return cells;
  }

  private flagCell(question, answer?: IAnswer) {
    if (!this.readonly) {
      const flagAns = cloneDeep(question);
      flagAns.answerId = answer && answer.id;
      flagAns.groupId = this.groupId;
      if (this.subGroup) {
        flagAns.subGroupId = this.subGroup.id;
        flagAns.subGroupName = this.subGroup.name;
      }
      if (this.rowIndex != null) {
        flagAns.rowIndex = this.rowIndex;
      }
      flagAns.row = this.rowAnswer;
      this.taxReturnSubcategoryService.setFlaggedAns(flagAns);
    }
  }

  private updateColumnOrdering() {
    if (!this.subGroup) return [];
    const questions: any[] = [...this.subGroup.questions.map(q => q)];
    questions.sort((a, b) => a.order - b.order);
    return questions;
  }

  newRow() {
    // new row answer
    const nextRowNumber = this.subGroup.rows.length;
    const newRow = { rowAnswer: null, cells: {}, ordinal: nextRowNumber };
    const rowIndex = this.subGroup.rows.length;
    this.subGroup.rows.push(newRow);

    this.subGroup.questions.forEach((q, i) => {
      const newAnswer = {
        answer: "",
        isNew: true
      };
      newRow.cells[q.id] = newAnswer;

      const control = makeControlForQuestion(q, true);

      this.formGroup.addControl(`${q.id}-${rowIndex}`, control);
      if (control.dirty && !this.formGroup.dirty) {
        this.formGroup.markAsDirty();
      }
    });
  }

  private handleAnswerChange(cell) {
    cell.question.subGroupId = this.subGroup.id;
    cell.question.subGroupName = this.subGroup.name;

    const originalAnswer =
      cell.answer && !cell.answer.isNew && cell.answer.answer != null
        ? cell.answer.answer
        : "";
    const valueHasChangedFromOriginal =
      cell.formControl.value !== originalAnswer;

    const commentField = cloneDeep(cell.question);
    commentField.answerChanged = valueHasChangedFromOriginal;
    commentField.rowIndex = this.rowIndex;

    // remove from array if val is same as previous
    if (!valueHasChangedFromOriginal) {
      cell.answer.answerChanged = false;
      this.taxReturnSubcategoryService.removeCommentField(commentField);
    } else {
      cell.answer.answerChanged = true;
      cell.displayAnswer = this.getDisplayAnswer(cell);
      if (this.taxReturnSubcategoryService.commentFieldExist(commentField)) {
        // Edit when the commentField was not due to an answer change, but now is
        this.taxReturnSubcategoryService.removeCommentField(commentField);
        this.taxReturnSubcategoryService.addCommentField(commentField);
      } else if (!this.readonly) {
        // Just add it
        this.taxReturnSubcategoryService.addCommentField(commentField);
      }
    }
  }

  readOnlyTable() {
    let foundEditableColumn = false;
    if (
      this.subGroup &&
      this.subGroup.questions &&
      this.subGroup.questions.length
    ) {
      foundEditableColumn = this.subGroup.questions.some(q => q.alwaysEditable);
    }
    return foundEditableColumn ? false : this.readonly;
  }

  selectRow(rowIndex) {
    this.subGroup.activeRow = rowIndex;
  }

  private focusTableInput(cell) {
    if (this.readonly || this.deleted) return false;
    if (!cell.formControl) {
      cell.formControl = makeControlForQuestion(
        cell.question,
        true,
        cell.answer
      );

      this.formGroup.addControl(
        `${cell.question.id}-${cell.rowIndex}`,
        cell.formControl
      );
    }

    if (cell.question.isBooleanCheckbox) {
      const val = cell.formControl.value ? "" : "true";
      cell.formControl.setValue(val);
      this.handleAnswerChange(cell);
    } else {
      cell.answer.isActive = true;
    }
  }
  labelClick(cellQuestion, cellAnswer) {
    const currentTab = this.taxReturnSubcategoryService.currentTab;
    if (this.inspectMode === "trace") {
      this.loadTrace.emit({ question: cellQuestion, answer: cellAnswer });
    } else if (currentTab === subcategoryTabs.flags) {
      this.flagCell(cellQuestion, cellAnswer);
    } else if (!this.readonly && currentTab === subcategoryTabs.comments) {
      this.commentCell(cellQuestion);
    }
  }
  private commentCell(question) {
    const commentField = cloneDeep(question);
    commentField.rowIndex = this.rowIndex;
    commentField.groupId = this.groupId;
    if (this.subGroup) {
      commentField.subGroupId = this.subGroup.id;
      commentField.subGroupName = this.subGroup.name;
    }

    this.taxReturnSubcategoryService.addCommentField(commentField);
  }
  cellClick(cell) {
    if (this.inspectMode) {
      this.labelClick(cell.question, cell.answer);
    } else {
      this.focusTableInput(cell);
    }
  }

  readonlyAlwaysEditableQuestion() {
    return (
      !this.taxReturn ||
      this.taxReturn.snapshotId != null ||
      !this.taxReturn.assignedUser ||
      this.taxReturn.assignedUser.id !== this.userInfo.id ||
      this.taxReturn.assignee.status === 99 ||
      this.taxReturn.userIsReadOnly ||
      this.taxReturn.fullStatus.readOnly
    );
  }
}

